import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=85b453f6"
import script from "./Reviews.vue?vue&type=script&lang=ts"
export * from "./Reviews.vue?vue&type=script&lang=ts"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=85b453f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports